import { render, staticRenderFns } from "./SwitchDialog.vue?vue&type=template&id=db8bcf86&"
import script from "./SwitchDialog.vue?vue&type=script&lang=js&"
export * from "./SwitchDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports